import { render, staticRenderFns } from "./CircleRecordStrokeIcon.vue?vue&type=template&id=1538e8f0&"
import script from "./CircleRecordStrokeIcon.vue?vue&type=script&lang=js&"
export * from "./CircleRecordStrokeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports